export default class Dialogs {
    constructor(dialogOpener) {

		this.dialogName   	= dialogOpener.dataset.dialog
		this.modalWindow 	= document.getElementById(this.dialogName);

		if(this.modalWindow){
			dialogOpener.addEventListener('click', () => {
                this.openModal();
            });
		}

    }

    openModal() {
        this.modalWindow.showModal()
		this.hideOnClickOutsideAlt(this.modalWindow,'member__openbutton')
    }


	hideOnClickOutsideAlt = (element, classExceptions) => {
		const outsideClickListener = event => {

			if( classExceptions && event.target.classList.contains(classExceptions) ){
				return;
			}

			element.close()
			removeClickListener();

		}
	
		const removeClickListener = () => {
			document.removeEventListener('click', outsideClickListener);
		}
	
		document.addEventListener('click', outsideClickListener);
	
	}

}